// @ts-nocheck
import React, { useState, useEffect } from 'react';
import _ from 'lodash';
import Tabs from '@/components/Tabs';
import TabHome from '@/components/TabHome';
import ShopIntroduce from '@/components/ShopIntroduce';
import utils from "@/utils/utils";
import kf from "@/assets/kf.png";
import services from "@/services";
import { base } from "@/services/api/_base";
import xf_x from "@/assets/xf_x.png";
import dzb_1 from "@/assets/dzb_1.png";
import shou from "@/assets/shou.png";
import dzb_x from "@/assets/dzb_x.png";
import hf_x from "@/assets/hf_x.png";
import dd from "@/utils/dd";
import jQuery from "jquery";
import Drawer from "../../components/drawer";
import "./index.scss";

const { apis } = services;

function Home2(props: any) {
  const { mallTest } = props;
  const [navsInfo, setNavsInfo] = useState<any>({});
  const [mark, setMark] = useState<any>({});
  const [activeIdFn, setActiveIdFn] = useState<any>(null);
  const [shopInfo, setShopInfo] = useState<any>({});
  const [pId, setPId] = useState<any>(null);
  const [showMc, setShowMc] = useState<boolean>(false);
  const [showDzb, setShowDzb] = useState<boolean>(false);
  const [bkImgDzb, setBkImgDzb] = useState<boolean>(false);
  const [showHf, setShowHf] = useState<boolean>(false);
  const [showXf, setShowXf] = useState<boolean>(true);
  const [imgXf, setImgXf] = useState<boolean>(false);
  const [dzbImgH, setDzbImgH] = useState<any>("auto");
  const [dzbImgHRes, setDzbImgHRes] = useState<any>("auto");
  const [carImgHDzb, setCarImgHDzb] = useState<any>("auto");
  const [carImgHHf, setCarImgHHf] = useState<any>("auto");
  const [touch, setTouch] = useState<boolean>(false);
  const [moduleDzb, setModuleDzb] = useState<any>({});
  const [moduleHf, setModuleHf] = useState<any>({});
  const [moduleXf, setModuleXf] = useState<any>({});
  const [brandId, setBrandId] = useState<any>();
  const [isShowIntroduce, setIsShowIntroduce] = useState<any>(false); // 是否展示店铺介绍弹窗
  // 公用变量
  let s = document.cookie;
  let d: any = new Date();
  // 24 * 60 * 60 * 1000
  d.setTime(d.getTime() + 24 * 60 * 60 * 1000);
  let timeout = false;
  let timmer: any = null;
  let timmer_31: any = null;
  let timmer_32: any = null;
  let timmer_4: any = null;
  let timmer_5: any = null;
  let timmer_6: any = null;
  const _providerId = utils.getUrlParam("providerId");
  const _pvMoudel = utils.getUrlParam("pvareaid")
    ? `&pvareaid=${utils.getUrlParam("pvareaid")}`
    : "";
  const _adMoudel = utils.getUrlParam("adChannel")
    ? `&adChannel=${utils.getUrlParam("adChannel")}`
    : "";

  // 切换tab时，初始化数据
  const initialization = () => {
    setModuleDzb("");
    setModuleHf("");
    setModuleXf("");
  };

  const getActiveObj = (tab: obj, fn: any) => {
    initialization();
    setActiveIdFn(() => fn);
    setMark(() => {
      return tab;
    });
  };

  // 设置导航栏标题
  const setBar = (info: any) => {
    if (utils.isInApp() && window.AHAPP) {
      window.AHAPP.invokeNative("actionbarinfo", {
        title: info.name || "汽车之家",
        addmenulist: [],
        stablemenulist: ["share"],
        // cityparam:0,   //0：显示App全局的定位城市, 1：显示App全局的用户选择城市
        success: function (result: any) {
          console.log("setBarSuccess", JSON.stringify(result)); //打印客户端返回的参数内容
          AHAPP.setNativeShareInfo({
            platform: "weixin&weixincircle",
            // platform: 'all',
            url: window.location.href,
            title: info.name || "",
            // content: info.slogan,
            imgurl: info.shopLogoUrl || "",
            success: function (result: any) {
              console.log("shareSuccess:", JSON.stringify(result));
            },
            fail: function (result: any) {
              console.log("shareSuccess:", JSON.stringify(result));
            },
          });
        },
        fail: function (result: any) {
          console.log(JSON.stringify(result));
        },
      });
      // 原生分享成功
      AHAPP.setNativeShareFinish({
        success: function (result: any) {
          console.log("shareSuccess:", JSON.stringify(result)); //打印客户端返回的参数内容
        },
        fail: function (result: any) {
          console.log("shareFail:", JSON.stringify(result));
        },
      });
    }
  };

  // 店铺api页头信息接口 navs
  const getShopHeaderFn = async () => {
    const params = {
      providerId: pId,
      sourceType: 2,
      isPreview: utils.getUrlParam("isPreview") || 0,
    };
    try {
      const res = await apis.getShopHeader(params);
      if (res.returncode === 0) {
        const _data = _.cloneDeep((res || {}).result || {});
        // *************先不进行筛选
        // _data.navs = _data.navs.filter((v: any) => v.isPage)
        // 返回数据中还有tabWrap的背景色
        setNavsInfo(() => _data);
      } else {
        alert(res.message || "");
      }
    } catch (e) {
      console.log(e);
    } finally {
    }
  };

  // 根据商家id查询商家信息-c端
  const getShopByDomainFn = async () => {
    const _appid = base.isProduct
      ? "3045a7e7-56d9-4c28-983c-18f61be65c71"
      : "1aaaa90e-4032-42ac-8616-d46fc8699f97";
    // const _timestamp = Number(new Date().getTime().toString().substr(0,10));
    // const _sign = md5(`appKey_appid${_appid}ids${ids}_timestamp${_timestamp}appKey`).toUpperCase();
    let params: any = {
      domain: _providerId,
      _appid,
    };
    // base.isProduct && delete params['_appid'];
    try {
      const res = await apis.getShopByDomain(params);
      if (Number(res.returnCode) === 0) {
        const _data = (res || {}).result || {};
        setShopInfo(() => _data);
        setPId(() => _data.providerId);
      } else {
        alert(res.message || "");
      }
    } catch (e) {
      console.log(e);
    } finally {
    }
  };

  const pvInfoUpdate = () => {
    let extendParams = {
      providerId: pId,
      userId: utils.getCookie("userId"),
      time: new Date().getTime(),
      mallTest,
    };
    extendParams = utils.formatParams(extendParams);
    window.trackPageView({
      ...window.pvTrack,
      type: "PV",
      ctime: new Date().getTime(),
      action: "ec_topic_mall_pv",
      element: "details",
      pmark: 1,
      pageVars: { ...extendParams },
    });
  };

  // 获取该店铺售卖的品牌ID
  const getBrandId = async () => {
    let params = { q: "", provider_id: pId };
    if (!base.isProduct) {
      params = { ...params, used_test: 1 };
    }
    const res = await apis.getGoodsList(params);
    if (res?.returncode === 0 && res.result?.list?.length > 0) {
      const good = res.result.list.find(
        (item) => item.data.cms_series_ids && item.data.cms_brand_ids
      );
      if (!good) {
        return;
      }
      setBrandId(good.data.cms_brand_ids);
    }
  };

  // 获取商品信息接口
  const getGoodsListFn = async (
    type: string,
    params: object,
    moduleTc: any
  ) => {
    try {
      const res = await apis.getGoodsList(params);
      if (Number(res.returncode) === 0) {
        const _data = _.cloneDeep((res || {}).result || {});
        const goodsObj = _.cloneDeep(_data);
        const _module = utils.getModuleTc(moduleTc, goodsObj);
        type === "dzb" && setModuleDzb(() => _module);
        type === "hf" && setModuleHf(() => _module);
        type === "xfIcon" && setModuleXf(() => _module);
      } else {
        alert(res.message || "");
      }
    } catch (e) {
      console.log(e);
    } finally {
    }
  };

  // 处理悬浮组件数据
  const getModuleTcArr = (_tcModuleArr: any) => {
    if (_tcModuleArr?.length > 0) {
      const { _moduleDzb, _moduleHf, _moduleXf } =
        utils.formatTcModuleArr(_tcModuleArr);
      // 悬浮icon
      if (Object.keys(_moduleXf).length > 0) {
        const {
          siteUserPoster: { contentType, goodsIds },
        } = _moduleXf;
        if (contentType === 1) {
          let _p = { q: "", provider_id: pId, bizid: goodsIds };
          if (!base.isProduct) {
            _p = { ..._p, used_test: 1 };
          }
          getGoodsListFn("xfIcon", _p, _moduleXf);
        } else {
          setModuleXf(() => _moduleXf);
        }
      } else {
        setModuleXf("");
      }
      // 大字报
      if (Object.keys(_moduleDzb).length > 0) {
        const {
          siteUserPoster: { contentType, goodsIds },
        } = _moduleDzb;
        if (contentType === 1) {
          let _p = { q: "", provider_id: pId, bizid: goodsIds };
          if (!base.isProduct) {
            _p = { ..._p, used_test: 1 };
          }
          getGoodsListFn("dzb", _p, _moduleDzb);
        } else {
          setModuleDzb(() => _moduleDzb);
        }
      } else {
        setModuleDzb("");
      }
      // 横幅
      if (Object.keys(_moduleHf).length > 0) {
        const {
          siteUserPoster: { goodsIds },
        } = _moduleHf;
        let _p = { q: "", provider_id: pId, bizid: goodsIds };
        if (!base.isProduct) {
          _p = { ..._p, used_test: 1 };
        }
        getGoodsListFn("hf", _p, _moduleHf);
      } else {
        setModuleHf("");
      }
    }
  };

  // 商品统一跳转
  const goToGoodDetail = (goodsObj: any, sourceid: any) => {
    const { list } = goodsObj;
    window.location.href = base.isProduct
      ? `https://mcar.mall.autohome.com.cn/frontEndPageStatic/productDetail/index.html?itemId=${list[0]?.id}&sourceid=${sourceid}&test=2021&mallTest=${mallTest}${_pvMoudel}${_adMoudel}`
      : `http://leads2.terra.autohome.com.cn/frontEndPageStatic/productDetail/index.html?itemId=${list[0]?.id}&sourceid=${sourceid}&test=20211230&mallTest=${mallTest}${_pvMoudel}${_adMoudel}`;
  };

  // 客服电话点击埋点
  const clickServer = () => {
    // 点击埋点
    let extendParams = {
      ...dd.ep,
      providerId: pId,
      mallTest,
    };
    extendParams = utils.formatParams(extendParams);
    utils.pvTrackLogger(
      "click",
      "ec_topic_mall_kefu_click",
      dd.baseParams,
      extendParams
    );
    window.location.href = `https://jjxq.autohome.com.cn/webapp/?businessId=BIS620867059865092096&userType=1${_pvMoudel}${_adMoudel}`;
  };
  const clickXfIcon = () => {
    const {
      siteUserPoster: { contentType, goodsObj, linkUrl },
    } = moduleXf;
    // 点击埋点
    let extendParams = {
      ...dd.ep,
      providerId: pId,
      brandId: contentType === 1 ? goodsObj?.list[0]?.data?.cms_brand_ids : "",
      mallTest,
    };
    extendParams = utils.formatParams(extendParams);
    utils.pvTrackLogger(
      "click",
      "ec_topic_mall_xficon_click",
      dd.baseParams,
      extendParams
    );
    if (contentType === 1) {
      goToGoodDetail(goodsObj, 200010);
    }
    if (contentType === 2) {
      if (linkUrl) {
        window.location.href = utils.linkUrl(linkUrl, 200010, mallTest);
      }
    }
  };
  const clickDzb = () => {
    const {
      siteUserPoster: { contentType, goodsObj, linkUrl },
    } = moduleDzb;
    // 点击埋点
    let extendParams = {
      ...dd.ep,
      providerId: pId,
      brandId: contentType === 1 ? goodsObj?.list[0]?.data?.cms_brand_ids : "",
      mallTest,
    };
    extendParams = utils.formatParams(extendParams);
    utils.pvTrackLogger(
      "click",
      "ec_topic_mall_baozhaping_click",
      dd.baseParams,
      extendParams
    );
    if (contentType === 1) {
      goToGoodDetail(goodsObj, 200008);
    }
    if (contentType === 2) {
      if (linkUrl) {
        window.location.href = utils.linkUrl(linkUrl, 200008, mallTest);
      }
    }
  };
  const clickHf = () => {
    const {
      siteUserPoster: { contentType, goodsObj },
    } = moduleHf;
    // 点击埋点
    let extendParams = {
      ...dd.ep,
      providerId: pId,
      brandId: contentType === 1 ? goodsObj?.list[0]?.data?.cms_brand_ids : "",
      mallTest,
    };
    extendParams = utils.formatParams(extendParams);
    utils.pvTrackLogger(
      "click",
      "ec_topic_mall_xuanfuchuang_click",
      dd.baseParams,
      extendParams
    );
    if (contentType === 1) {
      goToGoodDetail(goodsObj, 200009);
    }
  };

  const closeXfIcon = () => {
    setShowXf(() => false);
    const {
      siteUserPoster: { contentType, goodsObj },
    } = moduleXf;
    let extendParams = {
      ...dd.ep,
      providerId: pId,
      brandId: contentType === 1 ? goodsObj?.list[0]?.data?.cms_brand_ids : "",
      mallTest,
    };
    extendParams = utils.formatParams(extendParams);
    utils.pvTrackLogger(
      "click",
      "ec_topic_mall_xficon_guanbi_click",
      dd.baseParams,
      extendParams
    );
  };
  const closeDZB = () => {
    setShowMc(() => false);
    setShowDzb(() => false);
    const {
      siteUserPoster: { contentType, goodsObj },
    } = moduleDzb;
    let extendParams = {
      ...dd.ep,
      providerId: pId,
      brandId: contentType === 1 ? goodsObj?.list[0]?.data?.cms_brand_ids : "",
      mallTest,
    };
    extendParams = utils.formatParams(extendParams);
    utils.pvTrackLogger(
      "click",
      "ec_topic_mall_baozhaping_guanbi_click",
      dd.baseParams,
      extendParams
    );
    // 有横幅 有大字报
    document.cookie = `${_providerId}dzb=close;expires=` + d.toGMTString(); //设置cookie
    timmer = setTimeout(() => {
      if (Object.keys(moduleHf).length > 0) {
        if (s.indexOf(`${_providerId}hf=close`) !== -1) return;
        setShowHf(() => true);
      }
    }, 2000);
  };
  const closeHf = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    setShowHf(() => false);
    document.cookie = `${_providerId}hf=close;expires=` + d.toGMTString(); //设置cookie
    const {
      siteUserPoster: { contentType, goodsObj },
    } = moduleHf;
    let extendParams = {
      ...dd.ep,
      providerId: pId,
      brandId: contentType === 1 ? goodsObj?.list[0]?.data?.cms_brand_ids : "",
      mallTest,
    };
    extendParams = utils.formatParams(extendParams);
    utils.pvTrackLogger(
      "click",
      "ec_topic_mall_xuanfuchuang_guanbi_click",
      dd.baseParams,
      extendParams
    );
  };

  useEffect(() => {
    if (utils.isInApp() && shopInfo) {
      timmer_5 = setTimeout(() => {
        setBar(shopInfo);
      }, 300);
    }
  }, [JSON.stringify(shopInfo)]);

  useEffect(() => {
    if (pId) {
      getShopHeaderFn();
      getBrandId();
    }
  }, [pId]);

  useEffect(() => {
    getShopByDomainFn();
    // if (utils.isInApp()) {
    //   console.log('utils.isInApp()---getJSBridge()111111--', utils.isInApp());

    //   getJSBridge();
    // }
  }, []);

  useEffect(() => {
    if (showMc) {
      timmer_6 = setTimeout(() => {
        setShowDzb(() => true);
      }, 100);
    }
  }, [showMc]);
  useEffect(() => {
    // 1 有大字报 没有横幅  或两者都有
    // 1) 初始化大字报未关闭
    if (Object.keys(moduleDzb).length > 0) {
      // 大字报、横幅全关闭
      if (
        s.indexOf(`${_providerId}dzb=close`) !== -1 &&
        s.indexOf(`${_providerId}hf=close`) !== -1
      )
        return;
      // 大字报关闭、横幅未关闭
      if (
        s.indexOf(`${_providerId}dzb=close`) !== -1 &&
        s.indexOf(`${_providerId}hf=close`) === -1
      ) {
        setShowHf(() => true);
      }
      // 均未关闭即初始化（大字报关闭后，横幅弹出，或只有大字报）
      if (
        s.indexOf(`${_providerId}dzb=close`) === -1 &&
        s.indexOf(`${_providerId}hf=close`) === -1
      ) {
        setShowMc(() => true);
      }
    }
    // 2 有横幅 没大字报
    if (
      Object.keys(moduleHf).length > 0 &&
      Object.keys(moduleDzb).length === 0
    ) {
      // 仅设置关闭失效时间
      if (s.indexOf(`${_providerId}hf=close`) !== -1) return;
      // 弹窗代码
      setShowHf(() => true);
    }
  }, [JSON.stringify(moduleDzb), JSON.stringify(moduleHf)]);

  // 总pv、uv
  useEffect(() => {
    if (pId) {
      let extendParams = {
        ...dd.ep,
        providerId: pId,
        mallTest,
      };
      extendParams = utils.formatParams(extendParams);
      utils.pvTrackLogger(
        "show",
        "ec_topic_mall_zongpv_show",
        {
          ...dd.baseParams,
          area: "top",
        },
        extendParams
      );
      utils.pvTrackLogger(
        "show",
        "ec_topic_mall_zonguv_show",
        {
          ...dd.baseParams,
          area: "top",
        },
        extendParams
      );

      // trackPageView
      pvInfoUpdate();
    }
  }, [pId]);
  // 悬浮icon
  useEffect(() => {
    // 如果存在则曝光
    if (Object.keys(moduleXf).length > 0) {
      const {
        siteUserPoster: { contentType, goodsObj },
      } = moduleXf;

      let extendParams = {
        ...dd.ep,
        providerId: pId,
        brandId:
          contentType === 1 ? goodsObj?.list[0]?.data?.cms_brand_ids : "",
        mallTest,
      };
      extendParams = utils.formatParams(extendParams);
      utils.pvTrackLogger(
        "show",
        "ec_topic_mall_xficon_show",
        dd.baseParams,
        extendParams
      );
    }
  }, [JSON.stringify(moduleXf)]);
  // 大字报曝光埋点
  useEffect(() => {
    if (Object.keys(moduleDzb).length > 0) {
      const {
        siteUserPoster: { contentType, goodsObj },
      } = moduleDzb;
      let extendParams = {
        ...dd.ep,
        providerId: pId,
        brandId:
          contentType === 1 ? goodsObj?.list[0]?.data?.cms_brand_ids : "",
        mallTest,
      };
      extendParams = utils.formatParams(extendParams);
      utils.pvTrackLogger(
        "show",
        "ec_topic_mall_baozhaping_show",
        dd.baseParams,
        extendParams
      );
    }
  }, [JSON.stringify(moduleDzb)]);
  // 横幅曝光埋点
  useEffect(() => {
    if (Object.keys(moduleHf).length > 0) {
      const {
        siteUserPoster: { contentType, goodsObj },
      } = moduleHf;
      let extendParams = {
        ...dd.ep,
        providerId: pId,
        brandId:
          contentType === 1 ? goodsObj?.list[0]?.data?.cms_brand_ids : "",
        mallTest,
      };
      extendParams = utils.formatParams(extendParams);
      utils.pvTrackLogger(
        "show",
        "ec_topic_mall_xuanfuchuang_show",
        dd.baseParams,
        extendParams
      );
    }
  }, [JSON.stringify(moduleHf)]);

  // 设置图片高度
  useEffect(() => {
    // @ts-ignore
    const dzbImgH = document.getElementById("cdzbImgH")?.offsetWidth * 1.65;
    if (dzbImgH > 0) {
      setDzbImgH(() => dzbImgH);
    }
    // @ts-ignore
  }, [document.getElementById("cdzbImgH")?.offsetWidth]);
  useEffect(() => {
    // @ts-ignore
    const dzbImgHRes =
      document.getElementById("cdzbImgHRes")?.offsetWidth * 0.75;
    if (dzbImgHRes > 0) {
      setDzbImgHRes(() => dzbImgHRes);
    }
    // @ts-ignore
  }, [document.getElementById("cdzbImgHRes")?.offsetWidth]);
  useEffect(() => {
    // @ts-ignore
    const carImgHDzb =
      document.getElementById("carImg_dzb")?.offsetWidth * 0.75;
    if (carImgHDzb > 0) {
      setCarImgHDzb(() => carImgHDzb);
    }
    // @ts-ignore
  }, [document.getElementById("carImg_dzb")?.offsetWidth]);
  useEffect(() => {
    // @ts-ignore
    const carImgHHf = document.getElementById("carImg_hf")?.offsetWidth * 0.75;
    if (carImgHHf > 0) {
      setCarImgHHf(() => carImgHHf);
    }
    // @ts-ignore
  }, [document.getElementById("carImg_hf")?.offsetWidth]);

  // 处理大字报背景图片及悬浮图片加载时机
  useEffect(() => {
    const dzbEle = document.getElementById("cdzbImgH");
    const dzbEleRes = document.getElementById("cdzbImgHRes");
    if (dzbEle) {
      let img = new Image();
      img.src = dzb_1;
      img.onload = () => {
        dzbEle.style.backgroundImage = `url(${dzb_1})`;
        timmer_31 = setTimeout(() => {
          setBkImgDzb(() => true);
        }, 100);
      };
    }
    if (dzbEleRes) {
      let img = new Image();
      const _src = moduleDzb.siteUserPoster.pictureUrl;
      img.src = _src;
      img.onload = () => {
        dzbEleRes.src = _src;
        timmer_32 = setTimeout(() => {
          setBkImgDzb(() => true);
        }, 100);
      };
    }
  }, [
    document.getElementById("cdzbImgH"),
    document.getElementById("cdzbImgHRes"),
  ]);
  useEffect(() => {
    const xfEle = document.getElementById("imgXf");
    if (xfEle) {
      let img = new Image();
      const _src =
        moduleXf.siteUserPoster.contentType === 1
          ? "https://x.autoimg.cn/qdty/online/1688719703975.png"
          : moduleXf.siteUserPoster.pictureUrl;
      img.src = _src;
      console.log("src", _src);
      img.onload = () => {
        console.log("图片加载完成");
        timmer_4 = setTimeout(() => {
          setImgXf(() => true);
        }, 100);
      };
    }
  }, [moduleXf, document.getElementById("imgXf")]);

  // 监听contentArea滚动条
  useEffect(() => {
    jQuery(document.getElementById("contArea")).scroll(function () {
      if (timeout) {
        clearTimeout(timeout);
      }
      timeout = setTimeout(function () {
        setTouch(() => false);
      }, 100);
    });
  }, [document.getElementById("contArea")]);

  useEffect(() => {
    return () => {
      clearTimeout(timeout);
      clearTimeout(timmer);
      clearTimeout(timmer_31);
      clearTimeout(timmer_32);
      clearTimeout(timmer_4);
      clearTimeout(timmer_5);
      clearTimeout(timmer_6);
    };
  }, []);

  if (JSON.stringify(shopInfo) === "{}" || !pId) {
    return null;
  }

  return (
    <div className="home">
      <img
        alt=''
        className="h-backdrop"
        src={
          navsInfo.background
            ? navsInfo.background
            : "https://x.autoimg.cn/qdty/online/1691461022362.jpeg"
        }
      />
      <div className="h-content">
        <div className="h-shopInfo">
          <div className="h-title">
            <img alt='' src={shopInfo && shopInfo.shopLogoUrl} />
            <span className="h-shop">{`${shopInfo && shopInfo.name}`}</span>
          </div>
          <Tabs navsInfo={navsInfo} getActiveObj={getActiveObj} pId={pId} />
        </div>
        <div
          id="contArea"
          className="h-contArea"
          onScroll={() => !touch && setTouch(() => true)}
        >
          <TabHome
            mark={mark}
            setMark={setMark}
            activeIdFn={activeIdFn}
            pId={pId}
            getModuleTcArr={getModuleTcArr}
            mallTest={mallTest}
            _pvMoudel={_pvMoudel}
            _adMoudel={_adMoudel}
            brandId={brandId}
          />
        </div>
      </div>

      <>
        {/* 客服 */}
        <img
          alt=''
          src={kf}
          className="kf"
          onClick={() => clickServer()}
          style={{
            opacity: touch ? 0.7 : "",
            right: touch ? -23.5 : "",
          }}
        />
        {/* 悬浮icon */}
        {Object.keys(moduleXf).length > 0 && (
          <div
            style={{
              display: showXf && imgXf ? "block" : "none",
              opacity: touch ? 0.7 : "",
              right: touch ? -30 : "",
            }}
            className="xfWrap"
          >
            <img
              alt=''
              id="imgXf"
              className={
                moduleXf.siteUserPoster.contentType === 1 ? "icon" : "icon tag"
              }
              src={
                moduleXf.siteUserPoster.contentType === 1
                  ? "https://x.autoimg.cn/qdty/online/1688719703975.png"
                  : moduleXf.siteUserPoster.pictureUrl
              }
              onClick={() => clickXfIcon()}
            />
            <img
              alt=''
              className="xf-close"
              style={{ display: imgXf ? "" : "none" }}
              src={xf_x}
              onClick={() => closeXfIcon()}
            />
          </div>
        )}
        {/* 大字报 */}
        {Object.keys(moduleDzb).length > 0 && (
          <>
            <span
              className="mengc"
              style={{ display: showDzb && bkImgDzb ? "" : "none" }}
            />
            <div
              // className={dzbShake ? 'dzbWrap shake' : 'dzbWrap'}
              className="dzbWrap"
              style={{
                transform: showDzb && bkImgDzb ? "scale(1)" : "scale(0)",
              }}
            >
              <span className="content">
                {moduleDzb.siteUserPoster.contentType === 1 ? (
                  <>
                    <div
                      id="cdzbImgH"
                      className="dzb"
                      style={{
                        height: dzbImgH,
                      }}
                      onClick={() => clickDzb()}
                    >
                      <span
                        className="youhui"
                        style={{
                          display: bkImgDzb ? "" : "none",
                          fontSize:
                            moduleDzb?.siteUserPoster?.goodsObj?.list[0]?.data?.worth.toString()
                              .length > 3
                              ? 24
                              : "",
                        }}
                      >
                        {`${
                          moduleDzb?.siteUserPoster?.goodsObj?.list[0]?.data
                            ?.worth || 0
                        }元购车权益`}
                      </span>
                      <span
                        className="dzb-goods"
                        style={{ display: bkImgDzb ? "" : "none" }}
                      >
                        {/* css width需要屏蔽 */}
                        <img
                          alt=''
                          id="carImg_dzb"
                          className="g-car"
                          src={
                            moduleDzb?.siteUserPoster?.goodsObj?.list[0]?.data
                              ?.img_url || ""
                          }
                          style={{ height: carImgHDzb }}
                        />
                        <span className="words">
                          {moduleDzb?.siteUserPoster?.goodsObj?.list[0]?.data
                            ?.title || ""}
                        </span>
                      </span>
                      <img
                        alt=''
                        src={shou}
                        className="dzb-finger"
                        style={{ display: bkImgDzb ? "" : "none" }}
                      />
                    </div>
                  </>
                ) : (
                  <img
                    alt=''
                    id="cdzbImgHRes"
                    className="dzbRes"
                    src={moduleDzb.siteUserPoster.pictureUrl}
                    style={{ height: dzbImgHRes }}
                    onClick={() => clickDzb()}
                  />
                )}
                <img
                  alt=''
                  className="dzb-close"
                  src={dzb_x}
                  onClick={() => closeDZB()}
                />
              </span>
            </div>
          </>
        )}
        {/* 横幅 */}
        {Object.keys(moduleHf).length > 0 && (
          <div
            style={{ display: showHf ? "flex" : "none" }}
            className="hfWrap"
            onClick={() => clickHf()}
          >
            <span className="hf-close" onClick={(e) => closeHf(e)}>
              <img alt='' src={hf_x} />
            </span>
            <img
              alt=''
              id="carImg_hf"
              className="hf-car"
              src={
                moduleHf?.siteUserPoster?.goodsObj?.list[0]?.data?.img_url || ""
              }
              style={{ height: carImgHHf }}
            />
            <span className="quanyi">
              <span className="title">
                {`${moduleHf?.siteUserPoster?.goodsObj?.list[0]?.data?.cms_brand_names} ${moduleHf?.siteUserPoster?.goodsObj?.list[0]?.data?.cms_series_names}`}
              </span>
              <span className="money">
                <span className="desc">{`${
                  moduleHf?.siteUserPoster?.goodsObj?.list[0]?.data?.worth || 0
                }元购车权益`}</span>
                <span className="tip">
                  <span className="xsj"></span>
                  <span className="words">限时抢购</span>
                </span>
              </span>
            </span>
            <span className="hf-btn">立即抢购</span>
          </div>
        )}
      </>
      <Drawer
        status={isShowIntroduce}
        width={"100%"}
        clickShadowAutoClose={true}
        click={(isShowIntroduce) => {
          setIsShowIntroduce(isShowIntroduce);
        }}
        direction={"bottom"}
      >
        <ShopIntroduce mark={mark} shopInfo={shopInfo} mallTest={mallTest} />
      </Drawer>
    </div>
  );
}

export default Home2;
